import React, { FC, useState } from "react";
import { NavArrowDownIcon } from "assets/svgs";
import clsx from "clsx";
import { css } from "@emotion/css";
import { Theme } from "evcharging/app/themes";
import useTheme from "evcharging/hooks/useTheme";
import Box from "evcharging/components/Box";
import useI18n from "evcharging/hooks/useI18n";

interface NavLinkDropdownProps {
  label: string;
  title: string;
  links: Array<{
    href: string;
    label: string;
    onClick?: () => void;
  }>;
}

const NavLinkDropdownDesktop: FC<NavLinkDropdownProps> = (props) => {
  const { label, links, title } = props;
  const [showMore, setShowMore] = useState<boolean>(false);

  const toggleShowMore = () => setShowMore(true);
  const toggleShowLess = () => setShowMore(false);

  const theme = useTheme();
  const { t } = useI18n();
  const classes = createStyles(theme);

  return (
    <div
      onMouseEnter={toggleShowMore}
      onMouseLeave={toggleShowLess}
      style={{ position: "relative" }}
    >
      <p className={classes.dropdownLink}>
        {label}
        <NavArrowDownIcon className={clsx(classes.showMoreIcon, showMore && classes.rotateIcon)} />
      </p>
      <div style={{display: showMore ? 'block' : 'none'}}>
        <Box className={classes.dropDownList}>
          <div className={classes.title}>{title}</div>
          {links.map((link, index) => (
            <a
              href={link.href}
              key={index}
              aria-label={link.label}
              className={classes.link}
              onClick={link.onClick}
            >
              {t(link.label)}
            </a>
          ))}
        </Box>
      </div>
    </div>
  );
};

const createStyles = (theme: Theme) => ({
  dropdownLink: css({
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    color: "inherit",
    fontWeight: 600,
    fontSize: "18px !important",
    transition: "all 300ms",
    "& svg": {
      marginLeft: theme.spacing(1),
      marginTop: 3
    }
  }),
  dropDownList: css({
    position: "absolute",
    backgroundColor: "#fff",
    zIndex: 1000,
    left: "98%",
    boxShadow: "0px 4px 37px rgba(0, 0, 0, 0.1)",
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(5, 5, 2, 3),
    borderRadius: theme.spacing(2),
    marginTop: theme.spacing(1),
    whiteSpace: "nowrap",
    transform: "translate(-50%, 0)"
  }),
  link: css({
    color: "#333",
    fontSize: 16,
    fontWeight: 600,
    marginBottom: theme.spacing(3),
    "&:hover": {
      color: theme.colors.accent
    }
  }),
  title: css({
    color: theme.colors.accent,
    fontSize: 12,
    fontWeight: 600,
    marginBottom: theme.spacing(3)
  }),
  showMoreIcon: css({
    transition: "all 200ms"
  }),
  rotateIcon: css({
    transform: "rotate(-180deg)"
  }),
  dropdownLabel: css({
    fontSize: 18,
    "&:hover": {
      textDecoration: "underline"
    }
  })
});

export default NavLinkDropdownDesktop;
